export const releaseNoteAllJp = [
  [
    {
      releaseDate: "2026-06-02T16:00",
      updatedDate: "2026-06-02T16:00",
      version: "12.0.0",
      introduction: "当社は、infoceanus製品のUX(User Experience)向上のため、常に製品改善に取り組んでいます。以下は、connectの最新アップデート情報です。",
      conclusion: "当社は、ユーザー皆様のフィードバックを基に、製品開発・改善を継続的に実施しております。infoceanus製品に関する改善提案やフィードバックがある場合は、connect-support@jrcs.co.jpまでメールでお知らせください。"
    },
    {
      title: "新機能",
      descriptions: [
        "NEW! カスタムダッシュボード機能\n最大8つのダッシュボードを追加できます。\nダッシュボードは共有またはプライベートに設定できます。\n必要なコンポーネントを1つのページに追加できます - チャネル値、トレンドチャート（最大4つ）、ライブトレンドチャート（最大4つ）\nニーズに合わせてレイアウトをカスタマイズできます。\nダッシュボードの任意の場所にフリーテキストラベルを追加できます。",
      ],
      images: [
        require('./images/v12-0-0_fig1.png').default,
        require('./images/v12-0-0_fig2.png').default,
        require('./images/v12-0-0_fig3.png').default,
        require('./images/v12-0-0_fig4.png').default,
        require('./images/v12-0-0_fig5.png').default,
      ],
    },
    {
      title: "改善点",
      descriptions: [
        "ライブトレンドチャート\n毎秒更新。\n線の太さと色をカスタマイズ可能。\n詳細についてはJRCSまでお問い合わせください。",
      ],
      images: [
        require('./images/v12-0-0_fig6.png').default,
      ],
    }
  ],
  [
    {
      releaseDate: "2026-02-24T16:00",
      updatedDate: "2026-02-24T16:00",
      version: "11.0.1",
      introduction: "当社は、infoceanus製品のUX(User Experience)向上のため、常に製品改善に取り組んでいます。以下は、connectの最新アップデート情報です。",
      conclusion: "当社は、ユーザー皆様のフィードバックを基に、製品開発・改善を継続的に実施しております。infoceanus製品に関する改善提案やフィードバックがある場合は、connect-support@jrcs.co.jpまでメールでお知らせください。"
    },
    {
      title: "新機能",
      descriptions: [
        "今後、サービス契約の新しいバージョンでは、ユーザーによる確認が必要になります。この確認は、使用するブラウザに関係なく有効です。",
        "小型画面（スマートフォン、タブレットなど）向けにフリートオーバービューを更新しました。",
      ],
      images: [],
    }
  ],
    [
    {
      releaseDate: "2025-09-18T16:00",
      updatedDate: "2025-09-18T16:00",
      version: "11.0.0",
      introduction: "当社は、infoceanus製品のUX(User Experience)向上のため、常に製品改善に取り組んでいます。以下は、connectの最新アップデート情報です。",
      conclusion: "当社は、ユーザー皆様のフィードバックを基に、製品開発・改善を継続的に実施しております。infoceanus製品に関する改善提案やフィードバックがある場合は、connect-support@jrcs.co.jpまでメールでお知らせください。"
    },
    {
      title: "新機能",
      descriptions: [
        "NEW! カスタムチャンネルグループ機能\n船舶ごとに最大15個のカスタムグループを追加できます",
        "NEW! トレンドグラフ\nデジタルチャンネルが追加できるようになりました。\nデザインが新しくなりました。"
      ],
      images: [
        require('./images/v11-0-0_fig1.png').default,
        require('./images/v11-0-0_fig2.png').default,
        require('./images/v11-0-0_fig3.png').default,
        require('./images/v11-0-0_fig4.png').default,
      ],
    },
    {
      title: "改善点",
      descriptions: [
        "トレンドデータページでカスタムグラフを追加できるようになりました。\n船１隻につき最大16個のカスタムグラフを追加できるようになりました。",
        "カスタムグラフに追加チャネルを作成できるようになりました\nカスタムグラフごとに最大36チャネルを追加できるようになりました。",
        "トレンドデータページのグラフの値表示のデザイン変更\nグラフの右側に表示されるようになりました。\n文字サイズが大きくなりました。\nグラフにマウスオーバーすると、対応するデータがグラフの値表示の右側に表示されます。\nグラフをクリックすると、データ表示がロックされます。\nホバー選択のデザインがシンプルな下線に変更されました。",
        "データ比較ページで最大4つのグラフを比較できるようになりました",
        "トレンドグラフページのグラフ\nX軸とY軸をキーボードで操作できるようになりました",
      ],
      images: []
    }
  ],
  [
    {
      releaseDate: "2025-08-28T16:00",
      updatedDate: "2025-08-28T16:00",
      version: "10.2.8",
      introduction: "当社は、infoceanus製品のUX(User Experience)向上のため、常に製品改善に取り組んでいます。以下は、connectの最新アップデート情報です。",
      conclusion: "当社は、ユーザー皆様のフィードバックを基に、製品開発・改善を継続的に実施しております。infoceanus製品に関する改善提案やフィードバックがある場合は、connect-support@jrcs.co.jpまでメールでお知らせください。"
    },
    {
      title: "改善点",
      descriptions: [
        "カスタムトレンドグラフにおけるCSVダウンロード機能の不具合を修正",
      ],
      images: []
    }
  ],
  [
    {
      startDate: "2025-07-29T15:00:00",
      endDate: "2025-07-29T17:00:00",
      updatedDate: "2025-07-28T15:00:00",
      introduction: "Infoceanus をより快適にご利用いただくため、明日7月29日（火）15:00～17:00（日本時間）の間、バックグラウンドアップデートを実施いたします。このアップデートはシームレスに実行されるよう設計されており、ご利用に支障はございません。",
      conclusion: "アップデート中も通常通りConnect をご利用いただけます。何か問題が発生した場合は、connect-support@jrcs.co.jp までお気軽にお問い合わせください。迅速に調査し、できる限り早く対応いたします。",
    },
  ],
  [
    {
      releaseDate: "2025-02-20T17:00:00",
      updatedDate: "2025-02-20T17:00:00",
      version: "10.2.7",
      introduction: "当社は、infoceanus製品のUX(User Experience)向上のため、常に製品改善に取り組んでいます。以下は、connectの最新アップデート情報です。",
      conclusion: "当社は、ユーザー皆様のフィードバックを基に、製品開発・改善を継続的に実施しております。infoceanus製品に関する改善提案やフィードバックがある場合は、connect-support@jrcs.co.jpまでメールでお知らせください。",
    },
    {
      title: "改善点",
      descriptions: [
        "航海データページおよび貨物データページにおけるコンパス表示の不具合を修正",
      ],
      images: [],
    },
  ],
  [
    {
      releaseDate: "2025-01-28T16:00:00",
      updatedDate: "2025-01-28T16:00:00",
      version: "10.2.6",
      introduction: "当社は、infoceanus製品のUX(User Experience)向上のため、常に製品改善に取り組んでいます。以下は、connectの最新アップデート情報です。",
      conclusion: "当社は、ユーザー皆様のフィードバックを基に、製品開発・改善を継続的に実施しております。infoceanus製品に関する改善提案やフィードバックがある場合は、connect-support@jrcs.co.jpまでメールでお知らせください。",
    },
    {
      title: "改善点",
      descriptions: [
        "CSVファイルに記録される日付のタイムゾーン形式を変更"
      ],
      images: [],
    },
  ],
  [
    {
      releaseDate: "2025-01-17T16:00:00",
      updatedDate: "2025-01-17T16:00:00",
      version: "10.2.5",
      introduction: "当社は、infoceanus製品のUX(User Experience)向上のため、常に製品改善に取り組んでいます。以下は、connectの最新アップデート情報です。",
      conclusion: "当社は、ユーザー皆様のフィードバックを基に、製品開発・改善を継続的に実施しております。infoceanus製品に関する改善提案やフィードバックがある場合は、connect-support@jrcs.co.jpまでメールでお知らせください。",
    },
    {
      title: "改善点",
      descriptions: [
        "リリースノート（日本語）において、タイトルおよび日付の形式を変更.",
      ],
      images: [],
    },
  ],
  [
    {
      releaseDate: "2025-01-16T16:00:00",
      updatedDate: "2025-01-16T16:00:00",
      version: "10.2.4",
      introduction: "当社は、infoceanus製品のUX(User Experience)向上のため、常に製品改善に取り組んでいます。以下は、connectの最新アップデート情報です。",
      conclusion: "当社は、ユーザー皆様のフィードバックを基に、製品開発・改善を継続的に実施しております。infoceanus製品に関する改善提案やフィードバックがある場合は、connect-support@jrcs.co.jpまでメールでお知らせください。",
    },
    {
      title: "新機能",
      descriptions: [
        "ソフトウェアのバージョンと更新履歴を記載した「更新履歴」のページを追加",
        "トレンドデータのカスタム機能にて、グラフに複合データ（アナログデータ、デジタルデータ）を表示した際のY軸の表示構成を変更",
      ],
      images: [require("./images/v10-2-4_fig1.png").default,],
    },
    {
      title: "改善点",
      descriptions: [
        "トレンドデータのカスタム画面にて、ヘッダーの船舶選択の表示切替に対応（複数隻使用の場合に限る）",
      ],
      images: [],
    },
  ],
  [
    {
      releaseDate: "2024-12-25T16:00:00",
      updatedDate: "2024-12-25T16:00:00",
      version: "10.2.3",
      introduction: "当社は、infoceanus製品のUX(User Experience)向上のため、常に製品改善に取り組んでいます。以下は、connectの最新アップデート情報です。",
      conclusion: "当社は、ユーザー皆様のフィードバックを基に、製品開発・改善を継続的に実施しております。infoceanus製品に関する改善提案やフィードバックがある場合は、connect-support@jrcs.co.jpまでメールでお知らせください。",
    },
    {
      title: "改善点",
      descriptions: [
        "トレンドデータにて、デジタルとアナログ両方のチャンネルデータを含むグラフ表示において、ズームインおよびズームアウトの性能を向上",
        "トレンドデータのカスタム機能にて、全てのデジタルチャンネルデータを表示できるように改善",
      ],
      images: [],
    },
  ],
  [
    {
      releaseDate: "2024-12-19T16:00:00",
      updatedDate: "2024-12-19T16:00:00",
      version: "10.2.2",
      introduction: "当社は、infoceanus製品のUX(User Experience)向上のため、常に製品改善に取り組んでいます。以下は、connectの最新アップデート情報です。",
      conclusion: "当社は、ユーザー皆様のフィードバックを基に、製品開発・改善を継続的に実施しております。infoceanus製品に関する改善提案やフィードバックがある場合は、connect-support@jrcs.co.jpまでメールでお知らせください。",
    },
    {
      title: "改善点",
      descriptions: [
        "モニタリングページのマイナーなデザイン修正",
      ],
      images: [],
    },
  ],
  [
    {
      releaseDate: "2024-12-19T16:00:00",
      updatedDate: "2024-12-19T16:00:00",
      version: "10.2.1",
      introduction: "当社は、infoceanus製品のUX(User Experience)向上のため、常に製品改善に取り組んでいます。以下は、connectの最新アップデート情報です。",
      conclusion: "当社は、ユーザー皆様のフィードバックを基に、製品開発・改善を継続的に実施しております。infoceanus製品に関する改善提案やフィードバックがある場合は、connect-support@jrcs.co.jpまでメールでお知らせください。",
    },
    {
      title: "改善点",
      descriptions: [
        "トレンドデータのカスタム機能にて\n利用可能な全てのチャンネルタイプをチャートに選択・表示できるように改善\n編集機能を改善\nグラフ読み込みのアイコンを追加",
        "トレンドデータのダウンロードにて、CSVファイル内の時刻をUTCおよびLTの形式に対応",
      ],
      images: [],
    },
  ],
  [
    {
      releaseDate: "2024-12-17T16:00:00",
      updatedDate: "2024-12-17T16:00:00",
      version: "10.2.0",
      introduction: "当社は、infoceanus製品のUX(User Experience)向上のため、常に製品改善に取り組んでいます。以下は、connectの最新アップデート情報です。",
      conclusion: "当社は、ユーザー皆様のフィードバックを基に、製品開発・改善を継続的に実施しております。infoceanus製品に関する改善提案やフィードバックがある場合は、connect-support@jrcs.co.jpまでメールでお知らせください。",
    },
    {
      title: "新機能",
      descriptions: [
        "ひとつのユーザーが複数の管理会社の船舶を管理できるようマルチテナント機能を追加",
        '航海データの主機および補機燃料消費量の単位に関する対応\n標準の単位はKLで表示、オプションとしてKG, TON, GALに対応',
        "トレンドデータの閾値通知に関するデザイン更新",
        "ヘッダーのタイムゾーンのデザイン更新\n時刻表示をUTCとLT（現地時刻）で選択できるように対応\nトレンドデータのデータダウンロードは、選択しているタイムゾーンに基づき実施",
        "航海データの真風向と相対風向に関するデザイン更新",
      ],
      images: [],
    },
    {
      title: "改善点",
      descriptions: [
        "アプリケーションのパフォーマンス改善\nチャンネルページのデータ読み込み、応答時間を改善\nトレンド比較ページの読み込み、応答時間を改善\nトレンドデータの読み込み、応答時間を改善",
        "通信状態（オンライン/オフライン）のアラートメールの設定を更新",
        "トレンドデータのカスタム機能にて、編集と削除の機能を改善",
        "トレンドデータのグラフのスナップショットのファイル名に選択されているタイムゾーンの時刻を反映",
        "警報ページにて、アラームのステータスとデータの概要表示を改善",
        "トレンドデータにて、１秒間隔のデータをダウンロードする機能を対応（対応船のみ）",
        "ビジネスパートナー向けのAPIサービスの機能を改善",
      ],
      images: [],
    },
  ],
];